import { ButtonPrimary } from "../../base/BaseButton";
import styled, { css } from 'styled-components';
import {
    Dropdown as RsuiteDropdown,
    List as RsuiteList,
    Loader as RsuiteLoader,
    ButtonToolbar as RsuiteToolbar
} from "rsuite";

export const ButtonToolbar = styled(RsuiteToolbar)`
    width: 100%;
    display: inline-block; 
    
    ${props =>
        props.width && css`
            width: ${props.width};
        `
    }
`;

export const Footer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media (max-width: 575px) {
        flex-direction: column;
        gap: 10px;
    }
`;


export const CancelButton = styled(ButtonPrimary)`
    && {
        background-color: #8e8e93;
        border-color: #8e8e93;
        color: #ffffff;
        width: 100%;

        &:focus,
        &:hover,
        &:focus:hover,
        &:active:hover,
        &:active:focus,
        &:active.focus {
            background-color: #6f6f75;
            border-color: #6f6f75;
            color: #ffffff;
        }

        ${props =>
            props.width && css`
                width: ${props.width};
            `
        }
    }
`;


export const Dropdown = styled(RsuiteDropdown).attrs(props => {
    return {
        appearance: "primary",
        color: "green"
    };
})`
    overflow: visible;
    position: relative;
    z-index: 1;

    & > .rs-dropdown-toggle {
        width: 100%;
    }
    && .rs-dropdown-toggle {
        align-items: center;
        background-color: var(--color-secondary) !important;
        border-color: var(--color-secondary) !important;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 4px;
        color: #ffffff !important;
        display: inline-flex;
        gap: 6px;
        justify-content: center;
        padding: 12px 18px !important;
        padding-right: 32px !important;
        width: 100%;
    }
    .rs-dropdown-toggle-caret {
        margin-left: 8px !important;
    }
    && .rs-dropdown-toggle:not(:disabled):not(.rs-btn-disabled):hover,
    && .rs-dropdown-toggle:not(:disabled):not(.rs-btn-disabled):focus,
    && .rs-dropdown-toggle:not(:disabled):not(.rs-btn-disabled):active {
        background-color: var(--color-secondary-hover) !important;
        border-color: var(--color-secondary-hover) !important;
        color: #ffffff !important;
    }
    &&.rs-dropdown-disabled > .rs-dropdown-toggle.rs-btn,
    && > .rs-dropdown-toggle.rs-btn:disabled {
        background-color: #939191 !important;
        border-color: #939191 !important;
        color: #ffffff !important;
        opacity: 0.3 !important;
    }
    .rs-dropdown-menu {
        max-width: calc(100vw - 32px);
        min-width: 100%;
        width: max-content;
        z-index: 1065;
    }
    .rs-dropdown-item-content {
        overflow-wrap: anywhere;
        white-space: normal;
    }

    width: 100%;
`;


export const Loader = styled(RsuiteLoader)`
    & span.rs-loader-spin {
        margin-top: 3px;
        margin-right: 5px;
    }
`;


export const List = styled(RsuiteList)`
    margin-top: 10px;
    box-shadow: none !important;

    @media(max-width: 767px) {
        display: none !important;
    }
`;
